import { render } from "./DownloadWithPin.vue?vue&type=template&id=1588fd3f"
import script from "./DownloadWithPin.vue?vue&type=script&lang=js"
export * from "./DownloadWithPin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_webpack@5.109.2_postcss@8.5.24_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__